import React from "react";
import './footer.style.scss';

const Footer = () => {
    return (
        <div className="footer">
            <div
                className="footer-container frame"
                style={{ width: '80%', margin: '0 auto', padding: '20px 0' }}
            >

                {/* Copyright */}
                <div
                    className="footer-section"
                    style={{ textAlign: 'right', marginTop: '12px' }}
                >
                    <p style={{ fontSize: 'small' }}>
                        <a
                            href="/copyright"
                            style={{ textDecoration: 'none', color: 'var(--fontblack1)', marginLeft: '8px' }}>
                            © 2024 Reach
                        </a>
                    </p>
                </div>

                {/* About Us, Terms, Privacy */}
                <div
                    className="footer-section"
                    style={{ textAlign: 'right', display: "flex", justifyContent: "flex-end", marginTop: '12px' }}
                >
                    <p style={{ fontSize: 'small' }}>
                        <a
                            href="/about"
                            style={{ textDecoration: 'none', color: 'var(--fontblack1)', fontWeight: 400 }}>
                            About
                        </a> |
                    </p>
                    <p style={{ fontSize: 'small' }}>
                        <a
                            href="/careers"
                            style={{ textDecoration: 'none', color: 'var(--fontblack1)', fontWeight: 400, marginLeft: '8px' }}>
                            Careers |
                        </a>
                    </p>
                    <p style={{ fontSize: 'small' }}>
                        <a
                            href="/contact"
                            style={{ textDecoration: 'none', color: 'var(--fontblack1)', fontWeight: 400, marginLeft: '8px' }}>
                            Contact |
                        </a>
                    </p>
                    <p style={{ fontSize: 'small' }}>
                        <a
                            href="/terms"
                            style={{ textDecoration: 'none', color: 'var(--fontblack1)', fontWeight: 400, marginLeft: '8px' }}>
                            Terms & Conditions
                        </a> |
                    </p>
                    <p style={{ fontSize: 'small' }}>
                        <a
                            href="/privacy"
                            style={{ textDecoration: 'none', color: 'var(--fontblack1)', fontWeight: 400, marginLeft: '8px' }}>
                            Privacy Policy
                        </a>
                    </p>
                </div>

            </div>
        </div>
    );
};

export default Footer;
